(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var MC_URL = 'https://alexandrepronovost.us8.list-manage.com/subscribe/post-json?u=b499530147ef4b2a3e48e46ba&id=3454638108&f_id=00ad7be1f0';

    function submitToMailchimp(email, fname, lname, consent) {
      var params = [
        'EMAIL=' + encodeURIComponent(email),
        'FNAME=' + encodeURIComponent(fname),
        'LNAME=' + encodeURIComponent(lname),
        'MERGE7=' + encodeURIComponent(consent),
        'b_b499530147ef4b2a3e48e46ba_3454638108=',
        'c=afp_mc_callback'
      ].join('&');

      var script = document.createElement('script');
      script.src = MC_URL + '&' + params;
      document.body.appendChild(script);
      setTimeout(function () {
        if (script.parentNode) script.parentNode.removeChild(script);
      }, 5000);
    }

    window.afp_mc_callback = function (data) {};

    var contactForms = document.querySelectorAll('.afp_contact_form');
    contactForms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var emailField = form.querySelector('input[name="contact[email]"]');
        var firstNameField = form.querySelector('input[name="contact[Prénom]"]');
        var lastNameField = form.querySelector('input[name="contact[Nom]"]');
        var subscribeCheckbox = form.querySelector('input[name="contact[Infolettre]"]');

        if (emailField && emailField.value && subscribeCheckbox && subscribeCheckbox.checked) {
          submitToMailchimp(
            emailField.value,
            firstNameField ? firstNameField.value : '',
            lastNameField ? lastNameField.value : '',
            'oui'
          );
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presentation-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Fermeture generique : bouton close + clic sur le fond (backdrop)
    document.querySelectorAll('.afp_presentation_dialog').forEach(function (dialog) {
      var closeBtn = dialog.querySelector('[data-dialog-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          dialog.close();
        }
      });

      dialog.addEventListener('close', function () {
        var media = dialog.querySelector('audio, video');
        if (media) {
          media.pause();
        }
      });
    });

    // Ouverture generique des modals audio/video via data-dialog-target
    document.querySelectorAll('[data-dialog-target]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var dialog = document.getElementById(trigger.getAttribute('data-dialog-target'));
        if (!dialog) return;
        dialog.showModal();
        var media = dialog.querySelector('audio, video');
        if (media) {
          media.currentTime = 0;
          media.play();
        }
      });
    });

    // Galerie d'images : index partage + prev/next
    var galleryTriggers = Array.prototype.slice.call(document.querySelectorAll('.afp_presentation_gallery_trigger'));
    if (galleryTriggers.length) {
      var galleryDialog = document.querySelector('.afp_presentation_gallery_dialog');
      var galleryImg = galleryDialog ? galleryDialog.querySelector('[data-gallery-img]') : null;
      var currentIndex = 0;

      function showImageAt(index) {
        if (!galleryImg || !galleryTriggers.length) return;
        currentIndex = (index + galleryTriggers.length) % galleryTriggers.length;
        galleryImg.src = galleryTriggers[currentIndex].getAttribute('data-full');
      }

      galleryTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          showImageAt(parseInt(trigger.getAttribute('data-index'), 10) || 0);
          if (galleryDialog) galleryDialog.showModal();
        });
      });

      if (galleryDialog) {
        var prevBtn = galleryDialog.querySelector('[data-gallery-prev]');
        var nextBtn = galleryDialog.querySelector('[data-gallery-next]');
        if (prevBtn) prevBtn.addEventListener('click', function () { showImageAt(currentIndex - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { showImageAt(currentIndex + 1); });

        galleryDialog.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') showImageAt(currentIndex - 1);
          if (event.key === 'ArrowRight') showImageAt(currentIndex + 1);
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
